import { render } from "./FooterTurtles.vue?vue&type=template&id=ee111792&scoped=true"
import script from "./FooterTurtles.vue?vue&type=script&lang=js"
export * from "./FooterTurtles.vue?vue&type=script&lang=js"

import "./FooterTurtles.vue?vue&type=style&index=0&id=ee111792&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee111792"]])

export default __exports__